import { useMemo } from 'react';
import dayjs from 'dayjs';
import { Card, CardContent, CardActions, Stack, Typography, Button } from '@mui/material';
import type { CampaignType } from 'types/campaignTypes';

import UpcomingCampaignsContainer, { CardActionsWrapper, CardContentWrapper, ChannelLabel } from './UpcomingCampaigns.style';
import { CHANNEL_LABELS, CHANNEL_COLORS } from '../../constants';

type PropsType = {
  campaigns: CampaignType[];
  onEditClick?: (item: CampaignType) => void;
  onCancelClick?: (item: CampaignType) => void;
} & React.ComponentPropsWithoutRef<'div'>;

const UpcomingCampaigns: React.FC<PropsType> = ({
  campaigns,
  onEditClick = () => null,
  onCancelClick = () => null,
}) => {
  const upcomingCampaigns = useMemo(() => (campaigns.map((item) => {
    const recipientsCount = item.recipients.reduce((acc) => acc + 1, 0);
    const formatedRecipientsCount = recipientsCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formatedDate = dayjs(item.scheduledAt).format('MMM DD, h:mm A');

    return {
      ...item,
      recipientsCount,
      formatedRecipientsCount,
      formatedDate,
    };
  })), [campaigns]);

  return (
    <UpcomingCampaignsContainer>
      <Typography variant="h5" gutterBottom>
        Upcoming Messages
      </Typography>

      {upcomingCampaigns.map((campaignItem) => (
        <Card
          key={campaignItem.id}
          variant="outlined"
          className="campaign-card"
        >
          <CardContentWrapper>
            <Stack direction="row" spacing={2}>
              <ChannelLabel color={CHANNEL_COLORS[campaignItem.channel]}>
                {CHANNEL_LABELS[campaignItem.channel]}
              </ChannelLabel>
              <Typography variant="h6" gutterBottom>
                {campaignItem.subject}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Typography variant="body1" gutterBottom sx={{ color: 'text.secondary' }}>
                {campaignItem.formatedDate} • {campaignItem.formatedRecipientsCount} recipients
              </Typography>
            </Stack>
          </CardContentWrapper>
          <CardActionsWrapper>
            <Button
              size="small"
              variant="outlined"
              onClick={() => onEditClick(campaignItem)}
            >
              Edit
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => onCancelClick(campaignItem)}
            >
              Cancel
            </Button>
          </CardActionsWrapper>
        </Card>
      ))}
    </UpcomingCampaignsContainer>
  );
};

export default UpcomingCampaigns;
